import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import ScrollToTop from 'routes/ScrollToTop';
import { routes } from './routes/routes';
import Layout from './components/Layout';
import { HelmetProvider } from 'react-helmet-async';

function App() {
	return (
		<>
			<HelmetProvider>
				<Router>
					<ScrollToTop />
					<Layout>
						<Routes>
							{routes.map(({ path, component: Component, exact }) => (
								<Route key={path} path={path} element={<Component />} exact={exact} />
							))}
						</Routes>
					</Layout>
				</Router>
			</HelmetProvider>
		</>
	);
}

export default App;
